const routes = {
  path: "/borradores",
  component: () => import("./Module.vue"),
  meta: { requiresAuth: true },
  children : [
    {
      path : '',
      name: "Borradores",
      component: () => import("./views/Borradores.vue"),
    },
    {
      path : 'nuevo',
      name: "NuevoBorrador",
      props: route => Object.assign({}, route.params, route.query),
      component: () => import("./views/borrador-router.vue"),
    },
    {
      path : ':id',
      name: "EditarBorrador",
      props: route => Object.assign({}, route.params, route.query),
      component: () => import("./views/borrador-router.vue"),
    },
  ]
};

export default routes;
